import { Base } from "../../framework/base";
import { AppReportTemplateEditItem, IAppReportTemplateEditItem } from "../appReportTemplate/appReportTemplateEditItem";

export interface IAppReportNewUnitChange {
    appReportTemplates: IAppReportTemplateEditItem[];
}

export class AppReportNewUnitChange implements IAppReportNewUnitChange {
    appReportTemplates: AppReportTemplateEditItem[];
    constructor();
    constructor(obj: IAppReportNewUnitChange);
    constructor(obj?: any) {
        this.appReportTemplates = Base.getTypedArray(obj?.appReportTemplates, AppReportTemplateEditItem);
    }
}